import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import PropTypes from "prop-types";

const FMUSelect = ({
  required,
  label,
  form: { dirty, touched, errors },
  field,
  options,
  fullWidth,
  margin,
  ...other
}) => {
  const id = `sel_${field.name}`;
  const errorText = errors[field.name];
  const hasError = dirty && touched[field.name] && errorText !== undefined;

  const renderValue = (event) => {
    return event;
  };

  return (
    <Select
      {...field}
      renderValue={renderValue.bind(this)}
      inputProps={{
        label,
        id: `select_${id}`,
        classes: {
          // underline: classes.underLine
        },
      }}
      {...other}
    >
      {options && options.length
        ? options.map((item, index) => (
            <MenuItem key={index} value={item} component="div" button>
              {item}
            </MenuItem>
          ))
        : null}
    </Select>
  );
};

FMUSelect.propTypes = {
  // label: PropTypes.string.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    dirty: PropTypes.bool,
    errors: PropTypes.object,
  }).isRequired,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(["none", "dense", "normal"]),
};

FMUSelect.defaultProps = {
  required: false,
  fullWidth: true,
  margin: "normal",
};

export default FMUSelect;
